var Curriculog = Curriculog || {};

Curriculog.ProposalTabs = (function ($, _, Backbone, ProposalTabs) {

	ProposalTabs = Backbone.View.extend({

		el: function() {
			return $('#curriculog-list-column-tabs');
		},

		events: {
			'click li': 'execute',
		},

		initialize: function(options) {
			this.user = options.user;
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
			this.showAllProposals = proposals.userPermissions.permissions.showAllProposals;

			var html = this.render();
			this.$el.append(html);
			this.set();
		},

		render: function() {
			return nunjucks.render('ProposalList/proposalListTabs.html',
				{
					user: this.user,
					tab: this.params.domParams.get('tab'),
					showAllProposals: this.showAllProposals,
					level: this.params.domParams.get('level')
				}
			);
		},

		set: function() {
			// When coming from a session,
			// reapply that tab in the UI
			var tab = this.params.domParams.get('tab');
			this.$el.find('li').removeClass('active');
			this.$el.find('li.' + tab + '-tab').addClass('active');
		},

		execute: function(event) {
			event.preventDefault();

			// When switching tabs, change active class to current target
			var $currentTarget = $(event.currentTarget);
			var filter = $currentTarget.attr('class').match(/(\w*-?\w*)-tab/)[1];

			this.$el.find('li').removeClass('active');
			$currentTarget.addClass('active');

			// set the selected tab as filter for dom
			this.params.domParams.set('tab', this.getActiveTab());
			this.params.domParams.set('filterType', 'tab');

			// set the default tab search as query param
			var defaultQuery = this.defaultQueries[this.getActiveTab()].getDefaultParams();
			this.params.queryParams.set(defaultQuery);

			// Broadcast tab change and get event
			Backbone.trigger('tabs:change');
			Backbone.trigger('filter:submit');
		},

		getActiveTab: function() {
			return this.$el.find('li.active').attr('class').match(/(\w*-?\w*)-tab/)[1];
		}

	});

	return ProposalTabs;

})($, _, Backbone, Curriculog.ProposalTabs || {});
